import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";

const TRADITIONAL = ["Charge", "Wait", "Leave"];
const RESTPOWER = ["Charge", "Enter", "Eat / Work / Relax", "Continue Your Journey"];

const Flow = ({ steps, accent }) => (
  <div className="flex flex-wrap items-center gap-x-3 gap-y-3">
    {steps.map((s, i) => (
      <span key={s} className="flex items-center gap-3">
        <span
          className={`rounded-full border px-4 py-2 font-mono text-xs uppercase tracking-[0.1em] ${
            accent ? "border-rp-accent/40 bg-rp-accent/10 text-rp-accent" : "border-white/12 bg-white/[0.03] text-white/50"
          }`}
        >
          {s}
        </span>
        {i < steps.length - 1 && (
          <ArrowRight className={`h-4 w-4 ${accent ? "text-rp-accent" : "text-white/30"}`} />
        )}
      </span>
    ))}
  </div>
);

export default function WhySection() {
  return (
    <section className="border-y border-white/10 bg-rp-surface" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
            <Overline>Why RestPower</Overline>
            <h2 className="mt-5 font-display text-3xl font-light uppercase leading-[1.05] tracking-tight md:text-4xl lg:text-5xl">
              Charging the vehicle is only half the experience.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-white/55">
              Traditional charging locations primarily solve one thing — the vehicle's need for energy.
              RestPower is being designed around both the vehicle and the person waiting for it, so the
              time spent charging becomes time well spent.
            </p>
          </Reveal>

          <div className="space-y-6 lg:col-span-7">
            <Reveal delay={0.05} className="rounded-2xl border border-white/10 bg-rp-card p-8">
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/40">Traditional</span>
              <div className="mt-5"><Flow steps={TRADITIONAL} accent={false} /></div>
            </Reveal>
            <Reveal delay={0.12} className="rounded-2xl border border-rp-accent/25 bg-rp-card p-8 shadow-glow-sm">
              <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-rp-accent">RestPower</span>
              <div className="mt-5"><Flow steps={RESTPOWER} accent /></div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
